export default {
	props: {
		size: {
			type: String,
			default: 'sm'
		}
	},
	computed: {
		classes() {
			return [`icon-${this.size}`]
		}
	}
}
